import { render, staticRenderFns } from "./individual_school_considerations.vue?vue&type=template&id=3054da70&scoped=true"
import script from "./individual_school_considerations.vue?vue&type=script&lang=js"
export * from "./individual_school_considerations.vue?vue&type=script&lang=js"
import style0 from "./individual_school_considerations.vue?vue&type=style&index=0&id=3054da70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3054da70",
  null
  
)

export default component.exports